module.exports = __webpack_public_path__ + "img/1555270613.bed45ce0.jpg";